
'use strict';
module.exports = {
    init: function () {},
    end_loading: function () {
        document.querySelectorAll('body')[0].classList.remove('loading');
        let loadingFullPage = document.querySelectorAll('.loader')[0];
        loadingFullPage.parentNode.removeChild(loadingFullPage);
    }
};



// WEBPACK FOOTER //
// ./src/theme.js